import { TEXT } from "../consts/style";
import styled from "styled-components";
import { Link } from "@origin-digital/style-guide";

const StyledLink = styled(Link)`
  color: ${TEXT.LINK.STATIC};
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: ${TEXT.LINK.HOVER};
  }

  &:hover > svg {
    fill: ${TEXT.LINK.HOVER};
  }
`;

export { Link, StyledLink };
